const WIDGETS = '.elementor-widget-accordion, .elementor-widget-toggle, .elementor-widget-n-accordion';
const BOXES = '.e-con, .elementor-section, .elementor-column, .elementor-widget-wrap';

const accordionBackground = {
    init() {
        if (typeof window.ResizeObserver !== 'function') {
            return;
        }

        document.addEventListener('click', (event) => {
            const widget = event.target.closest ? event.target.closest(WIDGETS) : null;
            const box = widget ? this.box(widget) : null;

            if (box) {
                this.lock(box);
            }
        }, true);
    },

    box(widget) {
        for (let el = widget.parentElement; el && el !== document.body; el = el.parentElement) {
            if (el.dataset.exLocked || (el.matches(BOXES) && window.getComputedStyle(el).backgroundPositionY === '100%')) {
                return el;
            }
        }

        return null;
    },

    lock(box) {
        if (box.dataset.exLocked) {
            return;
        }

        let base = box.clientHeight;
        let width = box.clientWidth;

        box.dataset.exLocked = '1';
        box.style.transition = 'none';
        new ResizeObserver(() => {
            if (box.clientWidth !== width) {
                width = box.clientWidth;
                base = box.clientHeight;
            }

            box.style.backgroundPositionY = 'calc(100% - ' + (box.clientHeight - base) + 'px)';
        }).observe(box);
    },
};

export default accordionBackground;
